import {
    GetClientsRequest, GetClientsResponse,
} from "./requestsResponses";
import { ClientsApiMethods } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";


export const getClients = async (params: GetClientsRequest) => {
    const response = await execute<GetClientsRequest, GetClientsResponse>(
        ClientsApiMethods.getClients,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        clients: response.data.clients,
        total: response.data.total,
    }
};


